import Api from '@/services/api.js';

export default {
  addContractorProject(details) {
    return Api.post('contractorProjects/', details);
  },
  getAllContractorProjects() {
    return Api.get('contractorProjects/');
  },
  deleteContractorProject(contractorProject) {
    return Api.delete(`contractorProjects/${contractorProject}`);
  },
  updateContractorProject(contractorProject) {
    var contractorProjectId = contractorProject.id;
    return Api.put(`contractorProjects/${contractorProjectId}`, contractorProject);
  },
  // getContractorProjectsById(id, type) {
  //     if(type == 'contractor') {
  //         return this.getContractorProjectsByContractor(id)
  //     } else {
  //         return this.getContractorProjectsByProject(id)
  //     }       
  // },
  getContractorProjectsByContractor(id) {
    return Api.get('contractorProjects/byContractor/' + id);
  },
  getContractorProjectsByProject(id) {
    return Api.get('contractorProjects/byProject/' + id);
  },
}